export default __webpack_public_path__ + "static/media/sports05.28f1a4da.png";